"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_PLUGINS = void 0;
exports.PAYMENT_PLUGINS = {
    AUTHORIZE: 'AUTHORIZE',
    STRIPE: 'STRIPE',
    PAYPAL: 'PAYPAL'
};
//# sourceMappingURL=paymentPlugins.js.map